import React, { useEffect, useState } from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';
import { pointAPI } from '../../services';
import { toast } from 'react-toastify';

export default function ManualPointModal({
  show,
  onHide,
  employeeId,
  employeeName,
  currentMonth,
  payrollStatus,
  onSuccess,
}) {
  const [formData, setFormData] = useState({
    type: 'ADD',
    value: 0,
    reason: '',
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show) {
      setFormData({
        type: 'ADD',
        value: 0,
        reason: '',
      });
    }
  }, [show]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.value || formData.value <= 0) {
      toast.error('Vui lòng nhập giá trị điểm lớn hơn 0');
      return;
    }

    if (!formData.reason.trim()) {
      toast.error('Vui lòng nhập lý do');
      return;
    }

    if (!employeeId) {
      toast.error('Không xác định được nhân viên');
      return;
    }

    // Kiểm tra payroll status
    if (payrollStatus === 'APPROVED' || payrollStatus === 'PAID') {
      toast.error('Không thể thêm điểm cho bảng lương đã duyệt hoặc đã thanh toán');
      return;
    }

    try {
      setLoading(true);
      await pointAPI.createManualPoint({
        employee_id: employeeId,
        type: formData.type,
        value: formData.value,
        reason: formData.reason,
      });

      toast.success(
        formData.type === 'ADD' ? `Đã thêm ${formData.value} điểm thưởng` : `Đã trừ ${formData.value} điểm phạt`,
      );

      if (onSuccess) onSuccess();
      onHide();
    } catch (error) {
      console.error('Cannot create manual point', error);
      toast.error(error?.message || 'Không thể thêm/trừ điểm');
    } finally {
      setLoading(false);
    }
  };

  const canAddPoint = !payrollStatus || (payrollStatus !== 'APPROVED' && payrollStatus !== 'PAID');

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
    >
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>{formData.type === 'ADD' ? 'Thêm điểm thưởng' : 'Trừ điểm phạt'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {employeeName && (
            <div className="mb-3">
              <strong>Nhân viên:</strong> {employeeName}
            </div>
          )}

          {!canAddPoint && (
            <Alert
              variant="warning"
              className="mb-3"
            >
              <strong>⚠️ Lưu ý:</strong> Bảng lương đã {payrollStatus === 'APPROVED' ? 'duyệt' : 'thanh toán'}. Không
              thể thêm điểm cho bảng lương đã chốt.
            </Alert>
          )}

          <Form.Group className="mb-3">
            <Form.Label>Loại thao tác</Form.Label>
            <div>
              <Form.Check
                type="radio"
                label="Thưởng (ADD)"
                checked={formData.type === 'ADD'}
                onChange={() => setFormData({ ...formData, type: 'ADD' })}
                className="mb-2"
              />
              <Form.Check
                type="radio"
                label="Phạt (SUBTRACT)"
                checked={formData.type === 'SUBTRACT'}
                onChange={() => setFormData({ ...formData, type: 'SUBTRACT' })}
              />
            </div>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>
              Giá trị điểm <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="number"
              min={1}
              value={formData.value}
              onChange={(e) => setFormData({ ...formData, value: Number(e.target.value) })}
              placeholder="Nhập số điểm"
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>
              Lý do <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={formData.reason}
              onChange={(e) => setFormData({ ...formData, reason: e.target.value })}
              placeholder="Nhập lý do thưởng/phạt điểm"
              required
            />
          </Form.Group>

          <Alert
            variant="info"
            className="mb-0"
          >
            <strong>Ảnh hưởng:</strong>
            <br />
            {formData.type === 'ADD' ? (
              <>
                • 80% điểm ({Math.round(formData.value * 0.8)}) dùng để tính lương
                <br />• 20% điểm ({Math.round(formData.value * 0.2)}) cộng vào điểm tích luỹ
              </>
            ) : (
              <>• 100% điểm ({formData.value}) trừ lương tháng này</>
            )}
          </Alert>

          {currentMonth && (
            <div className="mt-2 small text-muted">Điểm sẽ được áp dụng khi tính lương tháng {currentMonth}</div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={onHide}
            disabled={loading}
          >
            Hủy
          </Button>
          <Button
            variant="primary"
            type="submit"
            disabled={loading || !canAddPoint}
          >
            {loading ? 'Đang xử lý...' : 'Xác nhận'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
